﻿'use strict';

angular.module('ntmApp').factory('HoursCompareFilter', function () {

    function HoursCompareFilter(labelPattern) {
        var pattern = labelPattern;
        this.hours = null;
        this.hoursComparator = ">=";

        this.isDefined = function () {
            return this.hours || this.hours === 0;
        };

        this.isPartlyDefined = function () {
            return this.hours || this.hours === 0;
        };

        this.clear = function () {
            this.hours = null;
            this.hoursComparator = ">=";
        };

        this.getLabel = function () {
            return pattern.format(this.hoursComparator, this.hours);
        };
    }

    return (HoursCompareFilter);
});